import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { toCurrentTld } from './workDomain';

declare const __OIDC_AUTHORITY__: string;
declare const __OIDC_CLIENT_ID__: string;

export const oidcAuthority: string = __OIDC_AUTHORITY__;
export const oidcClientId: string = __OIDC_CLIENT_ID__;

export const isOidcConfigured = !!oidcClientId && !!oidcAuthority;

export const userManager = new UserManager({
  // On the .work mirror the browser-side login redirect must hit auth's .work
  // counterpart, since auth.maxinsights.ai is geo-blocked. redirect_uri already
  // tracks the live origin below, so it follows the TLD automatically.
  authority: toCurrentTld(oidcAuthority || 'https://auth.maxinsights.ai/application/o/mlp/'),
  client_id: oidcClientId || 'dev',
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  scope: 'openid profile email offline_access',
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
});
